import { isToday } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

import { Appointment, BookAppointmentResponse } from "@/services/booking";

export class DateUtils {
  static formatAppointmentDate(
    appointment: Appointment | BookAppointmentResponse,
  ): string {
    return formatInTimeZone(
      new Date(appointment.start_datetime_tz),
      this.getAppointmentTZ(appointment),
      "MM/dd/yyyy",
    );
  }

  static formatAppointmentTime(
    appointment: Appointment | BookAppointmentResponse,
  ): string {
    return formatInTimeZone(
      new Date(appointment.start_datetime_tz),
      this.getAppointmentTZ(appointment),
      "h:mm a",
    );
  }

  static isAppointmentToday(
    appointment: Appointment | BookAppointmentResponse,
  ) {
    return isToday(new Date(appointment.start_datetime_tz));
  }

  private static getAppointmentTZ(
    appointment: Appointment | BookAppointmentResponse,
  ): string {
    if ("store" in appointment) {
      return appointment.store.tz;
    }
    return appointment.store_tz;
  }
}
